import * as con from './constants';

export const setMenuRouteFilterId = (payload: string) => ({
  type: con.MENU_ROUTE_FILTER_ID_SET,
  payload,
});

export const initRouteColapsible = (payload: Record<string, boolean>) => ({
  type: con.MENU_ROUTE_INIT_COLLAPSIBLE,
  payload,
});

export const setMenuRouteIsCollapsed = (payload: { id: string; isCollapsible: boolean }) => ({
  type: con.MENU_ROUTE_IS_COLLAPSIBLE_SET,
  payload,
});
